<div class="root-div">
  <button
    type="button"
    pButton
    pRipple
    icon="pi pi-file-pdf"
    pTooltip="Export PDF"
    tooltipPosition="bottom"
    class="p-button-text p-button-plain p-button-lg tool-bar-pbutton"
    (click)="menu.toggle($event)"></button>
  <p-menu #menu [model]="menuItems" [popup]="true" [appendTo]="'body'"></p-menu>
</div>
